import {inject} from '@angular/core';
import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {BenutzerModels} from '../models/benutzer-models';


export const ServiceAppLicenseGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    if (await inject(UserAuthenticationService).hasLicences(BenutzerModels.UserLicenses.CServiceApp)) {
        return true;
    } else {
        return new RedirectCommand(router.parseUrl('login/403/serviceapp'));
    }
};
